// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__bUdH5","detailsBorder":"styles_detailsBorder__2A0qp"};